import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from "@angular/core";
import { FormControl } from "@angular/forms";
import { debounceTime, distinctUntilChanged, Subject } from "rxjs";

@Component({
    selector: "app-search-bar",
    templateUrl: "./search-bar.component.html",
    styleUrl: "./search-bar.component.scss",
    standalone: false,
})
export class SearchBarComponent implements OnInit {
    @Input() label: string = "";
    @Input() placeholder: string = "Type to search...";
    @Input() debounceTime: number = 300;
    @Input() initialValue: string = "";
    @Input() appearance: "outline" | "fill" = "outline";
    @Input() showClearButton: boolean = true;
    @Input() minLength: number = 0;
    @Input() suffixSearchIcon!: string;
    @Input() suffixCloseIcon!: string;
    @Input() prefixIcon!: string;
    @Input() suffixWord!: string;
    @Input() pincode!: string;
    @Input() isPincodeInput: boolean = false;
    @Output() search = new EventEmitter<string>();
    @Output() clear = new EventEmitter<void>();

    public searchControl = new FormControl("");
    private searchClick$ = new Subject<string>();
    private isInitialLoad: boolean = true;

    ngOnInit() {
        this.searchControl.setValue(this.initialValue);
        if (this.pincode) {
            this.searchControl.setValue(this.pincode);
        }
        this.searchClick$
            .pipe(
                debounceTime(this.debounceTime),
                distinctUntilChanged(), // Adjust delay as needed
            )
            .subscribe((value) => {
                this.search.emit(value);
            });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes["pincode"]) {
            this.searchControl.setValue(this.pincode);
        }
    }

    // putting validation to pincode
    public allowOnlyDigits(event: KeyboardEvent) {
        if (this.isPincodeInput && !/^[0-9]$/.test(event.key)) {
            event.preventDefault();
        }
    }

    public handleClear(): void {
        this.searchControl.setValue("");
        this.clear.emit();
    }

    public handleSearch(): void {
        const value = this.searchControl.value?.trim() ?? "";
        if (value.length >= this.minLength) {
            this.searchClick$.next(value); // Emit value with debounce
        }
    }
}
